export default __webpack_public_path__ + "media/images/house-box-logo-0f2f0ebe9612d0a0eafa23247b0487d7.svg";